import { render, staticRenderFns } from "./overseasGrid.vue?vue&type=template&id=381a084a&scoped=true"
import script from "./overseasGrid.vue?vue&type=script&lang=js"
export * from "./overseasGrid.vue?vue&type=script&lang=js"
import style0 from "./overseasGrid.vue?vue&type=style&index=0&id=381a084a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a084a",
  null
  
)

export default component.exports